import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(8),
  margin: '0 auto',
  justifyContent: 'flex-start',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(5),
  },
  '& .SSSTitle': {
    color: theme.palette.common.white,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: theme.spacing(2.25),
    fontWeight: 600,
    lineHeight: '150%',
  },
  '& .SSSDivider': {
    width: '85%',
    color: theme.palette.common.white,
    marginBottom: theme.spacing(6),
    marginTop: theme.spacing(6),
    [theme.breakpoints.down('xl')]: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
    },
  },
  '& .SSSShareWrapper': {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  '& .SSSIconButton': {
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: '50%',
    border: 'none',
    backgroundColor: theme.palette.grey[200],
    padding: theme.spacing(0.5),
    transition: 'transform 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .SSIcon': {
      fontSize: theme.spacing(3.5),
      color: theme.palette.text.alternate,
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: theme.palette.grey[200],
    },
  },
}));

export default StyledBox;
